import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import helpers from '../../Utils/helpers';
import customerActions from '../../Actions/customerActions';
import CustomerInfoFlags from '../../Components/Customer/CustomerComponents/CustomerInfoFlags';
import Spinner, {SpinnerPosition, SpinnerSize} from "../../Components/Fundamentals/Spinner/Spinner";

const CustomerInfoFlagsContainer = () => {
    const dispatch = useDispatch();
    
    const customer = useSelector(state => state.CustomerReducer.customer);
    const relatedCustomers = useSelector(state => state.CustomerReducer.relatedCustomers);
    const customerInfoFlags = useSelector(state => state.CustomerReducer.customerInfoFlags);
    const customerInfoCounts = useSelector(state => state.CustomerReducer.customerInfoCounts);
    const infoFlagsLoading = useSelector(state => state.CommonReducer.dataLoading.customerInfoFlags);
    const relatedCustomersLoading = useSelector(state => state.CommonReducer.dataLoading.relatedCustomers);

    const isAoCustomer = customer.vbCustomer ? helpers.isAoCustomer(customer.vbCustomer) : false;

    useEffect(() => {
        if (!relatedCustomers && !relatedCustomersLoading && isAoCustomer) {
            dispatch(customerActions.getRelatedCustomers(customer.vbCustomer.customerNumber));
        }
        
        const customerNumber = customer.vbCustomer?.customerNumber || customer.vossCustomer?.customerNumber;
        if (customerNumber && !customerInfoFlags && !infoFlagsLoading) {
            dispatch(customerActions.getCustomerInfoFlags(customer));
        }
    }, [])

    if (infoFlagsLoading || relatedCustomersLoading)
        return <Spinner size={SpinnerSize.SMALL} position={SpinnerPosition.LEFT} />

    return <CustomerInfoFlags 
        customer={customer}
        customerInfoFlags={customerInfoFlags}
        customerInfoCounts={customerInfoCounts}
        relatedCustomers={relatedCustomers}
        customerActions={customerActions}
    />
}

export default CustomerInfoFlagsContainer;
